import { Component } from "react";

export class LeadsSearch extends Component {
  constructor(props) {
    super(props);

    // Default statuses to apply on reset
    this.defaultStatus = [
      "OPEN",
      "NOT_INTERESTED",
      "INTERESTED",
      "NOT_REACHABLE",
      "CALL_NOT_ANSWERED",
      "PENDING",
      "NOT_ELIGIBLE"
    ].join(",");

    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
        status: this.defaultStatus,
      },
      openDrawer: false,
    };

    this.fields = [
      {
        name: "productType",
        label: "Product Type",
        type: "select",
        options: [],
        placeholder: "Product Type",
      },
      {
        name: "status",
        label: "Status",
        type: "select", // or multiselect based on AppDynamicFilterModal
        options: _enum.ADMIN_LEADS_STATUS,
        placeholder: "Status",
      },
    ];

    this.isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  }

  componentDidMount() {
    // this.getProductTypes();
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      let productType = this.fields.find((o) => o.name === "productType");
      productType.options = res;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  // --------------------
  // SEARCH HANDLER
  // --------------------
  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);

    // If status is multi-select array → convert to comma string
    if (Array.isArray(data.status)) {
      data.status = data.status.join(",");
    }

    this.props.onSearch && this.props.onSearch(data, false);
  };

  // --------------------
  // RESET HANDLER
  // --------------------
  onReset = (formData, reset) => {
    let data = {};

    data.status = this.defaultStatus;

    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <>
        <div className="d-flex align-items-center justify-content-end py-3 pe-3">
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
             <i className="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
        </div>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </>
    );
  }
}

export default constore(LeadsSearch);
